export type Game = {
    title: string;
    description: string;
    images: string[];
}

export const games = [
    {
        title: "Shaman Showdown",
        description: "A wizard arena fighting game",
        images: ["1.png", "2.png"]
    }
]